<template>
  <div class="subscription-page">
    <subscription-details :placeholder="nonWebPlaceholder" />
    <section class="help">
      <p>
        Need Help? See
        <a
          href="https://getlasting.com/help#subscriptions-billing"
          target="_blank"
          >Subscription FAQs</a
        >
        or
        <a href="mailto:go-support@talkspace.com">Contact Us</a>
      </p>
    </section>
    <section>
      <cta-button
        type="button"
        class="button"
        :loading="isLoading"
        v-if="canCancel"
        @click="cancelSubscription()"
        >Start cancellation</cta-button
      >
      <cta-button
        type="button"
        class="button"
        :loading="isLoading"
        @click="logOut()"
        >Log out</cta-button
      >
    </section>
  </div>
</template>

<script>
import CtaButton from "@/components/CtaButton";
import SubscriptionDetails from "@/components/SubscriptionDetails";

export default {
  name: "SubscriptionPage",
  components: {
    CtaButton,
    SubscriptionDetails,
  },
  data() {
    const subscription = this.$user.user["subscription-info"];
    return {
      isLoading: false,
      error: null,
      nonWebPlaceholder: "Open the Lasting app to manage your account.",
      canCancel:
        subscription &&
        subscription.platform === "web" &&
        !subscription["subscription-end-date"],
    };
  },
  methods: {
    cancelSubscription() {
      this.$tracker.trackCancelStarted();
      this.$router.push({ name: "cancelReason" });
    },
    logOut() {
      this.$user.logOut();
      this.$router.push({ name: "logIn" });
    },
  },
};
</script>

<style lang="scss">
@import "@/style/variables";
@import "@/style/mixins";

.subscription-page {
  text-align: left;

  section:not(:last-child) {
    padding-bottom: 30px;

    &:not(:last-child) {
      border-bottom: 1px solid $light-gray;
    }

    &:not(:first-child) {
      padding-top: 30px;
    }
  }

  header {
    font-size: 16.5px;
    font-weight: 700;

    &:not(:first-child) {
      margin-top: 30px;
      border-top: 1px solid $light-gray;
      padding-top: 30px;
    }
  }

  .help p {
    font-size: 14px;
    line-height: 20px;

    a {
      font-weight: 700;
      font-size: 13.5px;
    }
  }
}
</style>
